import React from "react";
import SimpleLookupPage from "./SimpleLookupPage";
import useLocations from "../../hooks/useLocations";
import { LOCATION_ICON_OPTIONS } from "../../utils/locationIcons";

export default function LocationsPage() {
    const {
        locations,
        loading,
        error,
        fetchLocations,
        createLocation,
        updateLocation,
        deleteLocation,
    } = useLocations();

    return (
        <SimpleLookupPage
            title="Standorte / Umgebung"
            itemLabel="Standort"
            searchLabel="Standorte suchen"
            items={locations}
            loading={loading}
            error={error}
            fetchItems={fetchLocations}
            createItem={createLocation}
            updateItem={updateLocation}
            deleteItem={deleteLocation}
            iconOptions={LOCATION_ICON_OPTIONS}
        />
    );
}
